/*
 * @Author: wuchenge
 * @Date:   2022-04-06 18:26:59
 * @Last Modified by:   无尘阁
 * @Last Modified time: 2022-04-06 20:54:04
 */
import { fromJS } from "immutable";
import * as types from "./types";

const defaultState = fromJS({
  data: [],
});

export const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.DETAIL_CHANGE_DETAIL:
      return state.merge({
        data: action.data,
      });
    default:
      return state;
  }
};
